<!-- Loader -->
<div *ngIf="isSubmitting" class="container text-center my-5">
  <app-loading-spinner></app-loading-spinner>
</div>

<!-- Contenido -->
<div *ngIf="!isSubmitting" class="fixed-min">
  <div
    name="deleteContainer"
    class="position-relative float-end"
    style="top: -60px">
    <button
      *ngIf="currentEventSelected && rpaProcessIsSuccess"
      type="button"
      mat-fab
      color="warn"
      (click)="deleteSession()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  <div
    id="status-info"
    ngbTooltip="Estatus de la sesión"
    class="card mx-5 mb-2 p-1 border-2"
    [style.backgroundColor]="statusBarColor"
    *ngIf="currentEventSelected">
    <span class="text-light text-center"> {{ statusBarText }} </span>
  </div>

  <form
    *ngIf="sessionForm"
    [formGroup]="sessionForm"
    (ngSubmit)="enviarFormulario()"
    autocomplete="off"
    class="p-2">
    <div *ngIf="currentEventSelected">
      <h2 class="form-label title-blue-bimbo-cap">
        Id Localizador GBU: {{ currentEventSelected.idLocalizador }}
      </h2>
    </div>

    <div name="upper">
      <!-- R1  -->
      <!-- Filtros -->
      <div
        *ngIf="!isEditMode"
        class="d-flex gap-2 mx-2 mb-2 align-items-center flex-wrap">
        <!-- Año -->
        <span
          class="badge bg-light text-dark border px-3 py-2 d-flex align-items-center">
          <span class="me-2">Año:</span>
          <select
            class="form-select form-select-sm border-0 bg-transparent"
            style="min-width: 250px"
            [(ngModel)]="filterYear"
            [ngModelOptions]="{ standalone: true }"
            (change)="onFiltersChange()">
            <option [ngValue]="null">Todos</option>
            <option *ngFor="let y of years" [value]="y">
              {{ y }}
            </option>
          </select>
        </span>

        <!-- Mes -->
        <span
          class="badge bg-light text-dark border px-3 py-2 d-flex align-items-center">
          <span class="me-2">Mes:</span>
          <select
            class="form-select form-select-sm border-0 bg-transparent"
            style="min-width: 320px"
            [(ngModel)]="filterMonth"
            [ngModelOptions]="{ standalone: true }"
            (change)="onFiltersChange()">
            <option [ngValue]="null">Todos</option>
            <option *ngFor="let m of months" [value]="m.number">
              {{ m.label }}
            </option>
          </select>
        </span>
      </div>
      <!-- Evento -->
      <div class="col mx-2 mb-2">
        <label class="form-label title-blue-bimbo-cap mb-0"> *Evento: </label>

        <div class="input-group mb-1 position-relative">
          <!-- Skeleton -->
          <div *ngIf="isLoading && !isEditMode">
            <app-skeleton skeletonType="skeleton-input"></app-skeleton>
          </div>
          <!-- Select -->
          <select
            *ngIf="!isLoading && !currentEventSelected"
            id="idPlaneacionCurso"
            formControlName="idPlaneacionCurso"
            class="form-select"
            required
            (change)="onSelectEvent($event.target)">
            <option *ngFor="let d of eventPlans" [value]="d.idPlaneacion">
              {{ d.nombrePlaneacion }} - {{ d.mes }} - {{ d["año"] }}
            </option>
          </select>

          <!-- Readonly -->
          <input
            *ngIf="currentEventSelected"
            type="text"
            class="form-control"
            [value]="eventNameMonth"
            disabled />

          <!-- Botón info -->
          <div class="input-group-append mx-2">
            <button
              mat-icon-button
              name="details"
              matTooltip="Detalles del Evento"
              type="button"
              (click)="isCollapsed = !isCollapsed">
              <mat-icon matTooltip="Detalles del Evento">info </mat-icon>
            </button>
          </div>
        </div>

        <!-- Mensajes -->
        <div *ngIf="!isLoading && eventPlans.length === 0" class="mt-2">
          <small class="text-muted">
            No hay eventos para los filtros seleccionados
          </small>
        </div>

        <div *ngIf="!isLoading && eventPlans.length > 0" class="mt-2">
          <small class="text-muted">
            {{ eventPlans.length }} evento(s) disponibles
          </small>
        </div>

        <!-- Errores del form -->
        <div *ngIf="isValidField('idPlaneacionCurso')">
          <span class="form-text text-danger">
            {{ getFieldError("idPlaneacionCurso") }}
          </span>
        </div>

        <!-- Collapse -->
        <div #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed">
          <app-event-details
            *ngIf="this.selectedEventId && !isCollapsed"
            [eventId]="this.selectedEventId"
            #eventDetailsComponent>
          </app-event-details>
        </div>
      </div>
      <hr />
      <!-- Nombre de la sesion -->
      <div class="col mx-2">
        <div class="row mb-2">
          <label for="nombreSession" class="form-label title-blue-bimbo-cap"
            >*Nombre de la Sesión:</label
          >
          <input
            formControlName="nombreSession"
            id="nombreSession"
            type="text"
            class="form-control"
            required />
          <span
            class="form-text text-danger"
            *ngIf="isValidField('nombreSession')">
            {{ getFieldError("nombreSession") }}
          </span>
        </div>
      </div>
      <!-- Row 2 -->
      <div class="row">
        <!--Tipo de sesion-->
        <div class="col mx-2">
          <div class="row mb-2">
            <label for="tipoSesion" class="form-label title-blue-bimbo-cap"
              >*Tipo de Sesión</label
            >
            <select
              id="tipoSesion"
              formControlName="tipoSesion"
              class="form-select">
              <option
                *ngFor="let tipo of tiposSesion"
                [value]="tipo.id | number">
                {{ tipo.nombre }}
              </option>
            </select>
            <span
              class="form-text text-danger"
              *ngIf="isValidField('tipoSesion')">
              {{ getFieldError("tipoSesion") }}
            </span>
          </div>
        </div>
        <!-- Nivel -->
        <div class="col mx-2">
          <div class="row mb-2">
            <label for="nivel" class="form-label title-blue-bimbo-cap"
              >Nivel:</label
            >
            <input
              type="text"
              id="nivel"
              formControlName="nivel"
              class="form-control" />
            <div *ngIf="isValidField('nivel')">
              <span class="form-text text-danger">
                {{ getFieldError("nivel") }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <!--Tabla Ponentes -->
      <p class="form-label title-blue-bimbo-cap mt-2 mb-1">
        Instructor(es) ILT:
      </p>
      <div class="row">
        <div class="col">
          <div *ngIf="userList && isLoadingUsers">
            <app-user-input-searcher
              keyForId="sessionInstrctor"
              [userList]="userList"
              label="Buscar Instructor ILT"
              [defaultValue]="ponenteUser"
              [presetUser]="ponenteUser"
              (selectedUserEmitter)="addInstructor($event)">
            </app-user-input-searcher>
          </div>
          <div *ngIf="!userList || !isLoadingUsers">
            <app-skeleton skeletonType="skeleton-input"></app-skeleton>
          </div>
        </div>
      </div>

      <div class="form-control mt-2">
        <table
          class="table table-sm align-middle"
          aria-describedby="partes por sesión">
          <thead>
            <tr>
              <th>#</th>
              <th>Instructor(es) ILT</th>
              <th>Eliminar</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="userInstructores.length === 0">
              <td colspan="10">
                <div class="alert alert-secondary text-center" role="alert">
                  Agrega instructores.
                </div>
              </td>
            </tr>
            <tr *ngFor="let instuctor of userInstructores; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ instuctor.name }}</td>
              <td>
                <button
                  mat-icon-button
                  [disabled]="
                    rpaProcessIsPending ||
                    sessionHasAttendance ||
                    instuctor.id === userLogged?.id
                  "
                  color="warn"
                  (click)="removeInstructor(i)">
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <!-- Row 3 -->
      <div class="row">
        <!-- Ponentes -->
        <div class="col mx-2">
          <div class="row mb-2">
            <label for="ponentes" class="form-label title-blue-bimbo-cap"
              >Ponente externo:</label
            >
            <input
              type="text"
              id="ponentes"
              formControlName="ponentes"
              class="form-control" />
            <div *ngIf="isValidField('ponentes')">
              <span class="form-text text-danger">
                {{ getFieldError("ponentes") }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr />

    <!-- ubicacion -->
    <div class="col mx-2">
      <div class="row mb-2">
        <label for="location" class="form-label title-blue-bimbo-cap"
          >*Ubicación</label
        >
        <app-location-search
          [FormGroup]="sessionForm"
          controlName="location"></app-location-search>
        <div *ngIf="isValidField('location')">
          <span class="form-text text-danger">
            {{ getFieldError("location") }}
          </span>
        </div>
        <div *ngIf="locationHasIdError">
          <span class="form-text text-danger"
            >ID de la ubicaci&oacute;n no encontrado</span
          >
        </div>
      </div>
    </div>
    <!--Datepickers-->
    <hr />
    <p class="form-label title-blue-bimbo-cap mt-1 mb-1">*Añadir partes:</p>

    <div class="row align-items-center">
      <!-- Fecha  -->
      <div class="col-4">
        <div class="row">
          <label for="sessionDate" class="form-label title-blue-bimbo-cap"
            >Selecciona la fecha:</label
          >
          <div class="input-group">
            <input
              class="form-control"
              placeholder="yyyy-mm-dd"
              name="dp"
              [(ngModel)]="partBuilder.date"
              [ngModelOptions]="{ standalone: true }"
              ngbDatepicker
              (ngModelChange)="changeEndDate()"
              id="sessionDate"
              #d="ngbDatepicker" />
            <button
              class="btn-outline-secondary"
              (click)="d.toggle()"
              type="button">
              <i class="fa fa-calendar"></i>
            </button>
          </div>
        </div>
      </div>
      <!-- Hora Inicio de Sesion -->
      <div class="col">
        <div class="row mb-2">
          <label
            for="partStartDate"
            (ngModelChange)="verifyDates()"
            class="form-label title-blue-bimbo-cap"
            >Hora de Inicio:</label
          >
          <ngb-timepicker
            id="partStartDate"
            [(ngModel)]="partBuilder.startDate"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="verifyDates()"
            (keydown.enter)="$event.preventDefault()">
          </ngb-timepicker>
        </div>
      </div>
      <!-- Hora Finalización de Sesion -->
      <div class="col">
        <div class="row mb-2">
          <label for="partEndDate" class="form-label title-blue-bimbo-cap"
            >Hora de Finalización:</label
          >
          <ngb-timepicker
            id="partEndDate"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="partBuilder.endDate"
            (ngModelChange)="verifyDates()"
            (keydown.enter)="$event.preventDefault()">
          </ngb-timepicker>
        </div>
      </div>
      <div class="col">
        <div class="btn-add-part-fixed form-group">
          <button
            type="button"
            mat-mini-fab
            color="primary"
            [disabled]="rpaProcessIsPending || sessionHasAttendance"
            (click)="addSessionPart()">
            <mat-icon>add</mat-icon>
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <button
            type="button"
            mat-mini-fab
            color="primary"
            [disabled]="rpaProcessIsPending || sessionHasAttendance"
            (click)="eventRepeat()">
            <mat-icon>event_repeat</mat-icon>
          </button>
        </div>
      </div>
      <!-- Event Repeat-->
      <div class="row align-items-center" *ngIf="isEventRepeat">
        <div class="col-4">
          <div class="row">
            <label for="sessionDate2" class="form-label title-blue-bimbo-cap"
              >Fecha fin:</label
            >
            <div class="input-group">
              <input
                class="form-control"
                placeholder="yyyy-mm-dd"
                name="toDate"
                ngbDatepicker
                [(ngModel)]="endDate"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="verifyDates()"
                id="toDate"
                #d2="ngbDatepicker" />
              <button
                class="btn-outline-secondary"
                (click)="d2.toggle()"
                type="button">
                <i class="fa fa-calendar"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row">
            <label for="sessionDate2" class="form-label title-blue-bimbo-cap"
              >Selecciona los días:</label
            >
            <div class="input-group" [formGroup]="fgWeekDays">
              <table>
                <tr>
                  <td>
                    <mat-checkbox color="primary" formControlName="lunes1"
                      >Lu</mat-checkbox
                    >
                  </td>
                  <td>
                    <mat-checkbox color="primary" formControlName="martes2"
                      >Ma</mat-checkbox
                    >
                  </td>
                  <td>
                    <mat-checkbox color="primary" formControlName="miercoles3"
                      >Mi</mat-checkbox
                    >
                  </td>
                  <td>
                    <mat-checkbox color="primary" formControlName="jueves4"
                      >Ju</mat-checkbox
                    >
                  </td>
                  <td>
                    <mat-checkbox color="primary" formControlName="viernes5"
                      >Vi</mat-checkbox
                    >
                  </td>
                  <td>
                    <mat-checkbox color="primary" formControlName="sabado6"
                      >Sá</mat-checkbox
                    >
                  </td>
                  <td>
                    <mat-checkbox color="primary" formControlName="domingo0"
                      >Do</mat-checkbox
                    >
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="isValidField('partes')">
        <span class="form-text text-danger">{{ getFieldError("partes") }}</span>
      </div>
    </div>
    <!--Check para QR Maestro-->
    <div class="row mt-3 justify-content-center">
      <div class="col-auto text-center">
        <small class="text-muted d-block mb-1">
          Activa esta opción si la sesión utilizará QR Maestro
        </small>

        <mat-checkbox formControlName="qrMaestro" color="primary">
          QR Maestro
        </mat-checkbox>
      </div>
    </div>
    <!--Partes-->
    <p class="form-label title-blue-bimbo-cap mt-2 mb-1">
      Partes por sesion establecidas:
    </p>
    <div class="form-control mt-2">
      <p class="text-center">
        <small>
          <i
            >Si tu sesi&oacute;n contempla alg&uacute;n descanso, recuerda
            restarlo de la duraci&oacute;n total de la parte/sesi&oacute;n.</i
          >
        </small>
      </p>
      <table
        class="table table-sm align-middle"
        aria-describedby="partes por sesión">
        <thead>
          <tr>
            <th>Partes</th>
            <th>Fecha</th>
            <th class="text-center">Hora de inicio</th>
            <th class="text-center">Hora final</th>
            <th>Duraci&oacute;n</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="currentParts.length === 0">
            <td colspan="10">
              <div class="alert alert-secondary text-center" role="alert">
                Agrega partes de la sesión.
              </div>
            </td>
          </tr>
          <tr *ngFor="let parte of currentParts; let i = index">
            <td>Parte {{ i + 1 }}:</td>
            <td>
              {{
                parte.fecha
                  | date: "EEEE dd-MMM-yyyy" : "" : "es-mx"
                  | titlecase
              }}
            </td>
            <td>
              <ngb-timepicker
                id="partStartDate"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="parte.startDateTime"
                (ngModelChange)="onChangeTimeOnPartTable(parte)"
                (keydown.enter)="$event.preventDefault()"
                size="small"
                [class.invalid-time]="!parte.isValidStart"
                [spinners]="false">
              </ngb-timepicker>
            </td>

            <td>
              <ngb-timepicker
                id="partEndDate"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="parte.endDateTime"
                (ngModelChange)="onChangeTimeOnPartTable(parte)"
                (keydown.enter)="$event.preventDefault()"
                size="small"
                [class.invalid-time]="!parte.isValidEnd"
                [spinners]="false">
              </ngb-timepicker>
            </td>
            <td>
              {{
                (parte.fechaFin.valueOf() - parte.fechaInicio.valueOf()) /
                  1000 /
                  60 /
                  60 | number: "1.2-2"
              }}
              hora(s)
            </td>
            <td>
              <button
                mat-icon-button
                [disabled]="rpaProcessIsPending || sessionHasAttendance"
                color="warn"
                (click)="removeItem(i, parte)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </tr>
          <tr>
            <td colspan="10">
              <p class="form-label title-blue-bimbo-cap mt-2 mb-1 text-center">
                Total de Horas: {{ totalHoras(currentParts) | number: "1.2-2" }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-center align-content-center my-1">
      <div class="col-3 p-1" style="max-width: 200px">
        <button
          class="btn btn-primario"
          type="submit"
          [disabled]="
            (sessionForm.pristine && !rpaProcessFailed) ||
            rpaProcessIsPending ||
            sessionStatusIsDelete ||
            sessionHasAttendance ||
            currentPartsHasError
          ">
          <span
            *ngIf="rpaProcessFailed && !sessionStatusIsDelete; else normalBtn">
            <mat-icon>sync</mat-icon>
            Reintentar
          </span>
          <span *ngIf="rpaProcessIsPending || sessionStatusIsDelete">
            <mat-icon>block</mat-icon>
          </span>
          <ng-template #normalBtn>
            <span>
              {{ !!!currentEventSelected ? "Confirmar" : "Actualizar" }}
            </span>
          </ng-template>
        </button>
      </div>
      <div class="col-3 mx-1 p-1">
        <a
          type="button"
          style="max-width: 200px"
          class="btn btn-secondary-cap mx-1"
          (click)="cancel()">
          <span> Cancelar </span>
        </a>
      </div>
    </div>
  </form>
</div>
